import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { SxProps } from '@mui/system'
import { type CSSProperties, lazy, type ReactElement, type ReactNode, useEffect, useState } from 'react'

interface KNCallToActionProps {
  readonly image?: string
  readonly lottie?: string
  readonly header?: string
  readonly content?: string
  readonly children?: ReactNode
  readonly sx?: SxProps
}

const Lottie = lazy(() => import('lottie-react'))

const imageStyle: CSSProperties = { width: '20rem', borderRadius: '50%', border: '1rem solid #fff' }

const KNCallToAction = ({
  image,
  lottie,
  header,
  content,
  children,
  sx,
}: KNCallToActionProps): ReactElement => {
  const [animation, setAnimation] = useState<unknown>()

  useEffect(() => {
    if (!lottie) {
      setAnimation(undefined)
      return
    }
    (async () => {
      const animationFile = await fetch(lottie)
      animationFile.json().then(setAnimation)
    })()
  }, [lottie])

  return (
    <Stack spacing={4} justifyContent="center" alignItems="center" sx={sx}>
      {image && (
        <>
          {animation ? (
            <Lottie animationData={animation} loop={true} style={imageStyle}/>
          ) : (
            <img src={image} alt={header} loading="lazy" style={imageStyle} />
          )}
        </>
      )}
      <Stack spacing={1} alignItems="center">
        {header && (
          <Typography variant="p2" textAlign="center" color="primary">{header}</Typography>
        )}
        {content && (
          <Typography variant="p3" textAlign="center">{content}</Typography>
        )}
      </Stack>
      <Stack direction="row" spacing={1}>
        {children}
      </Stack>
    </Stack>
  )
}

export default KNCallToAction
